import React, { FC, useMemo } from 'react'
import FlexingContainer from '@sport1/news-styleguide/FlexingContainer'
import FooterTrademark from './FooterTrademark'
import { getTrademarksData } from './utils'
import { useTracking } from '@/utils/tracking/TrackingProvider'

const FooterTrademarkList: FC = () => {
    const { countryInfo } = useTracking()
    const trademarks = useMemo(() => getTrademarksData(countryInfo.country), [countryInfo])
    return (
        <FlexingContainer className="gap-[12px] md:gap-[24px]" horizontal flexWrap="wrap">
            {trademarks.map((trademark, index) => (
                <FooterTrademark trademark={trademark} key={`${trademark.title}-${index}`} />
            ))}
        </FlexingContainer>
    )
}

export default FooterTrademarkList
